import { memo } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import "./LoadingSpinner.css";

type Props = {
  className?: string;
  asIcon?: boolean;
};

export const Spinner = memo(({ className, asIcon }: Props) => (
  <div
    aria-live="polite"
    className={cnTwMerge(
      "gradient-spinner-loader",
      "inline-block",
      { "w-6 h-6": asIcon },

      className,
    )}
    data-testid="gradient-spinner"
    role="status"
  />
));
